function vcdOpenCartDrawer() {
  // 1. Custom cart app function (Sidecart / custom drawer)
  if (typeof window.vcdOpen === 'function') { window.vcdOpen(); return; }

  // 2. Dawn cart-drawer web component
  const drawer = document.querySelector('cart-drawer');
  if (drawer) {
    if (typeof drawer.open === 'function') { drawer.open(); return; }
    drawer.classList.add('is-open', 'active');
    return;
  }

  // 3. Cart notification (Dawn alternative to drawer)
  const notification = document.querySelector('cart-notification');
  if (notification && typeof notification.open === 'function') { notification.open(); return; }

  // 4. Click the header cart icon to open whatever drawer is hooked to it
  const cartBtn = document.querySelector('[aria-controls="CartDrawer"], [data-drawer-toggle="CartDrawer"], .site-header__cart');
  if (cartBtn) { cartBtn.click(); return; }
}

function vcdUpdateCartCount() {
  return fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      document.querySelectorAll('.cart-count-bubble span:not(.visually-hidden)').forEach(function (el) {
        el.textContent = cart.item_count;
      });
      document.querySelectorAll('.cart-count-bubble').forEach(function (el) {
        el.removeAttribute('hidden');
        el.classList.remove('hidden');
      });
      return cart;
    });
}

function vcdPostCartAdd(variantId) {
  return fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
    .then(function (r) {
      if (!r.ok) {
        return r.json().then(function (error) {
          throw new Error((error && error.description) || 'Cart add failed');
        });
      }
      return r.json();
    })
    .then(function (item) {
      return vcdUpdateCartCount().then(function () {
        vcdOpenCartDrawer();
        return item;
      });
    });
}

function vcdAddToCart(btn) {
  if (!btn || btn.disabled) return Promise.resolve();

  const variantId = parseInt(
    btn.dataset.variantId || (btn.closest('form') && btn.closest('form').querySelector('[name="id"]') && btn.closest('form').querySelector('[name="id"]').value),
    10
  );
  if (!variantId) return Promise.resolve();

  const origHTML = btn.innerHTML;
  btn.disabled = true;

  return vcdPostCartAdd(variantId)
    .then(function () {
      btn.classList.add('added');
      btn.innerHTML = 'Added!';
    })
    .then(function () {
      setTimeout(function () {
        btn.classList.remove('added');
        btn.innerHTML = origHTML;
        btn.disabled = false;
      }, 1800);
    })
    .catch(function () {
      btn.innerHTML = origHTML;
      btn.disabled = false;
    });
}

document.addEventListener('click', function (e) {
  // Scoped to --direct only: the picker's Add to Cart button (multi-variant
  // products) uses --picker and is handled by the card-variant-picker
  // custom element below, not this blind-add path.
  const btn = e.target.closest('.card-atc-btn--direct');
  if (!btn) return;
  e.preventDefault();
  e.stopPropagation();
  vcdAddToCart(btn);
}, true);

/* Shared variant-selection logic for the inline card pickers.
   Two arms extend this: card-variant-picker (pills) and card-variant-dropdown
   (selects). Everything that resolves a variant, judges availability, or talks
   to the cart lives here so both arms behave identically once a variant is
   chosen — only the control type differs. */
class VcdCardVariantBase extends HTMLElement {
  constructor() {
    super();

    this.addBtn = this.querySelector('[data-card-variant-picker-add], [data-card-variant-dropdown-add]');
    this.messageEl = this.querySelector('[data-card-variant-picker-message]');

    const dataEl = this.querySelector('.card-variant-picker__data');
    let parsed = {};
    try {
      parsed = dataEl ? JSON.parse(dataEl.textContent) : {};
    } catch (e) {
      parsed = {};
    }
    this.productData = parsed.product || null;
    this.currentVariantId = parsed.currentVariantId || null;
    this.selectedOptions = {};

    if (this.addBtn) this.addBtn.addEventListener('click', this._onAddClick.bind(this));
  }

  _variantById(id) {
    if (!this.productData || !Array.isArray(this.productData.variants) || !id) return null;
    return this.productData.variants.find((variant) => variant.id === id) || null;
  }

  _findMatchingVariant() {
    if (!this.productData || !Array.isArray(this.productData.variants)) return null;

    return this.productData.variants.find((variant) => {
      return variant.options.every((optionValue, index) => {
        return this.selectedOptions[String(index + 1)] === optionValue;
      });
    });
  }

  _isValueAvailable(position, value) {
    if (!this.productData || !Array.isArray(this.productData.variants)) return true;

    return this.productData.variants.some((variant) => {
      if (variant.options[position - 1] !== value) return false;
      if (!variant.available) return false;

      return Object.keys(this.selectedOptions).every((otherPosition) => {
        if (otherPosition === String(position)) return true;
        return variant.options[otherPosition - 1] === this.selectedOptions[otherPosition];
      });
    });
  }

  _setMessage(message, hide) {
    if (!this.messageEl) return;
    this.messageEl.textContent = message;
    this.messageEl.hidden = hide || !message;
  }

  // Overridden by arms that need to guard the click (e.g. incomplete selection).
  _onAddClick() {
    this._addSelectedVariant();
  }

  _addSelectedVariant() {
    if (!this.addBtn || this.addBtn.disabled || !this.currentVariantId) return;

    const originalText = this.addBtn.textContent;
    this.addBtn.textContent = 'Adding...';
    this.addBtn.disabled = true;

    vcdPostCartAdd(this.currentVariantId)
      .then(() => {
        this.addBtn.textContent = 'Added!';
        this.addBtn.classList.add('added');
        setTimeout(() => {
          this.addBtn.classList.remove('added');
          this._syncVariant();
        }, 900);
      })
      .catch((error) => {
        this.addBtn.textContent = originalText;
        this.addBtn.disabled = false;
        this._setMessage(error.message || 'Please try again.');
      });
  }
}

/* Card variant picker — inline pill selector for multi-variant products. */
if (!customElements.get('card-variant-picker')) {
  customElements.define('card-variant-picker', class CardVariantPicker extends VcdCardVariantBase {
    constructor() {
      super();

      this.pillGroups = this.querySelectorAll('.card-variant-picker__group');

      const currentVariant = this._variantById(this.currentVariantId);
      if (currentVariant) {
        currentVariant.options.forEach((value, index) => {
          this.selectedOptions[String(index + 1)] = value;
        });
      }

      this.querySelectorAll('.card-variant-picker__pill').forEach((button) => {
        button.addEventListener('click', () => this._selectOption(button));
      });

      this._refreshPillAvailability();
      this._syncVariant();
    }

    _selectOption(button) {
      if (button.disabled) return;

      const position = button.dataset.optionPosition;
      this.selectedOptions[position] = button.dataset.optionValue;

      this.querySelectorAll(`.card-variant-picker__pill[data-option-position="${position}"]`).forEach((optionButton) => {
        const isSelected = optionButton === button;
        optionButton.classList.toggle('is-selected', isSelected);
        optionButton.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });

      this._refreshPillAvailability();
      this._syncVariant();
    }

    _refreshPillAvailability() {
      this.querySelectorAll('.card-variant-picker__pill').forEach((button) => {
        const position = button.dataset.optionPosition;
        const value = button.dataset.optionValue;
        const available = this._isValueAvailable(position, value);
        button.disabled = !available;
        button.classList.toggle('is-unavailable', !available);
      });
    }

    _syncVariant() {
      const variant = this._findMatchingVariant();
      this.currentVariantId = variant ? variant.id : null;

      if (!this.addBtn) return;

      if (!variant) {
        this.addBtn.disabled = true;
        this.addBtn.textContent = 'Unavailable';
        this._setMessage('This combination is unavailable.');
        return;
      }

      this.addBtn.dataset.variantId = variant.id;
      this.addBtn.disabled = !variant.available;
      this.addBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      this._setMessage('', true);
    }
  });
}

/* Card variant dropdown — inline <select> arm of the collection-page A/B test.
   Nothing is preselected: each select opens on a "Select <Option>" placeholder
   and Add to Cart stays visually active, prompting instead of blocking. */
if (!customElements.get('card-variant-dropdown')) {
  customElements.define('card-variant-dropdown', class CardVariantDropdown extends VcdCardVariantBase {
    constructor() {
      super();

      this.selects = Array.from(this.querySelectorAll('.card-variant-dropdown__select'));

      this.selects.forEach((select) => {
        select.addEventListener('change', () => this._selectOption(select));
      });

      this._refreshOptionAvailability();
      this._syncVariant();
    }

    _selectOption(select) {
      const position = select.dataset.optionPosition;

      if (select.value) {
        this.selectedOptions[position] = select.value;
      } else {
        delete this.selectedOptions[position];
      }

      this._refreshOptionAvailability(position);
      this._syncVariant();
    }

    // Availability is cross-filtered: a size in stock in black may be sold out
    // in white, so every select is relabelled after each change.
    //
    // pinnedPosition is the select the shopper just changed. It is never
    // cleared — picking a colour that has no stock in the current size must
    // drop the size, not silently undo the colour they just chose.
    _refreshOptionAvailability(pinnedPosition) {
      let invalidated = false;

      this.selects.forEach((select) => {
        const position = select.dataset.optionPosition;

        Array.from(select.options).forEach((option) => {
          if (!option.value) return;

          const available = this._isValueAvailable(position, option.value);
          option.disabled = !available;
          option.textContent = available ? option.value : `${option.value} — Sold out`;

          // The shopper's newer choice just made this selection impossible.
          if (!available && select.value === option.value && position !== pinnedPosition) {
            select.value = '';
            delete this.selectedOptions[position];
            invalidated = true;
          }
        });
      });

      // Dropping a selection widens what's available elsewhere, so re-evaluate.
      // Terminates: the pinned select is never cleared and each pass must clear
      // at least one of the finitely many remaining selections.
      if (invalidated) this._refreshOptionAvailability(pinnedPosition);
    }

    _isSelectionComplete() {
      return this.selects.length > 0 && this.selects.every((select) => select.value);
    }

    _firstUnselected() {
      return this.selects.find((select) => !select.value) || null;
    }

    _syncVariant() {
      if (!this.addBtn) return;

      if (!this._isSelectionComplete()) {
        this.currentVariantId = null;
        delete this.addBtn.dataset.variantId;
        this.addBtn.disabled = false;
        this.addBtn.textContent = 'Add to Cart';
        this._setMessage('', true);
        return;
      }

      const variant = this._findMatchingVariant();
      this.currentVariantId = variant ? variant.id : null;

      if (!variant) {
        this.addBtn.disabled = true;
        this.addBtn.textContent = 'Unavailable';
        this._setMessage('This combination is unavailable.');
        return;
      }

      this.addBtn.dataset.variantId = variant.id;
      this.addBtn.disabled = !variant.available;
      this.addBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      this._setMessage('', true);
    }

    _onAddClick() {
      const pending = this._firstUnselected();

      if (pending) {
        const optionName = (pending.dataset.optionName || 'option').toLowerCase();
        this._setMessage(`Select a ${optionName}`);
        pending.focus();
        try {
          if (typeof pending.showPicker === 'function') pending.showPicker();
        } catch (e) {
          // showPicker() throws where unsupported or outside a user gesture;
          // focus alone is the fallback.
        }
        return;
      }

      this._addSelectedVariant();
    }
  });
}

// Mobile 1.5-card slider — flex-basis controls slide width in Dawn's flexbox slider
function vcdFixMobileSlider() {
  if (window.innerWidth > 749) return;
  document.querySelectorAll('.slider--tablet .grid__item').forEach(function (item) {
    item.style.flex = '0 0 calc(66% - 6px)';
    item.style.width = 'calc(66% - 6px)';
    item.style.maxWidth = 'calc(66% - 6px)';
    item.style.boxSizing = 'border-box';
  });
}

document.addEventListener('DOMContentLoaded', function () {
  setTimeout(vcdFixMobileSlider, 100);
  setTimeout(vcdFixMobileSlider, 500);
});

window.addEventListener('resize', vcdFixMobileSlider);
